export function isInvalid(field, formik) {
  const fieldMeta = formik.getFieldMeta(field);
  return fieldMeta.touched && !!fieldMeta.error;
}

export function setInvalidFieldTouched(
  field,
  errors,
  formik,
  validate = false,
) {
  if (errors instanceof Array) {
    errors.forEach((child, index) => {
      setInvalidFieldTouched(
        `${field}.${index}`,
        errors[index],
        formik,
        validate,
      );
    });
  } else if (errors instanceof Object) {
    Object.keys(errors).forEach((child) =>
      setInvalidFieldTouched(
        `${field}.${child}`,
        errors[child],
        formik,
        validate,
      ),
    );
  } else {
    formik.setFieldError(errors);
    formik.setFieldTouched(field, true, validate);
  }
}

export function collectErrorPaths(errors, prefix = "") {
  if (!errors) return [];
  if (typeof errors === "string") return prefix ? [prefix] : [];
  if (Array.isArray(errors)) {
    return errors.flatMap((item, index) =>
      collectErrorPaths(item, `${prefix}${prefix ? "." : ""}${index}`),
    );
  }
  if (typeof errors === "object") {
    return Object.keys(errors).flatMap((key) =>
      collectErrorPaths(
        errors[key],
        `${prefix}${prefix ? "." : ""}${key}`,
      ),
    );
  }
  return [];
}

export function buildTouchedFromPaths(paths) {
  const touched = {};
  paths.forEach((path) => {
    if (!path) return;
    const keys = path.split(".");
    let cursor = touched;
    keys.forEach((key, index) => {
      if (index === keys.length - 1) {
        cursor[key] = true;
        return;
      }
      if (!cursor[key] || typeof cursor[key] !== "object") {
        cursor[key] = {};
      }
      cursor = cursor[key];
    });
  });
  return touched;
}

export function getTouchedFromSchema(value, schema) {
  if (!schema) return {};
  try {
    schema.validateSync(value, { abortEarly: false });
    return {};
  } catch (error) {
    const paths = (error?.inner || [])
      .map((item) => item.path)
      .filter(Boolean);
    return buildTouchedFromPaths(paths);
  }
}

export function touchFieldsFromErrors(errors, formik) {
  const paths = collectErrorPaths(errors);
  if (paths.length === 0) return false;
  paths.forEach((path) => {
    formik.setFieldTouched(path, true, false);
  });
  return true;
}
